module.exports = __webpack_public_path__ + "static/img/RAOK-1M-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAOK-1M-G_1.png
// module id = pdGf
// module chunks = 0